





















import { Mobile } from "@/mixins/mobile";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderGetters } from "@/store/modules/order/types";
import { Order } from "@/models/order/order";
import { EventBus } from "@/event-bus";
import SurchargeBanner from "@/components/footer/SurchargeBanner.vue";

@Component({ components: { SurchargeBanner } })
export default class CheckoutFooter extends mixins(Mobile) {
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetOrder))
  storeOrder!: Order;

  get customerId(): string | undefined {
    return this.storeOrder.customer_id;
  }

  protected reviewQuote(): void {
    EventBus.$emit("reviewQuote");
  }
}
